<template>
  <v-row justify="center">
    <v-col class="auth-container">
      <v-row class="ma-2"><slot name="logo"></slot></v-row>
      <v-card class="elevation-12" tile>
        <v-card-title>
          <h2>New password</h2>
        </v-card-title>
        <v-card-text>
          <v-progress-linear v-if="!email"></v-progress-linear>
          <p v-else>
            Set your new password for <strong>{{ email }}</strong> account.
          </p>
          <v-form v-model="formValid" :disabled="loading" lazy-validation>
            <v-text-field
              filled
              labe="New password"
              type="password"
              required
              v-model="password"
              autocomplete="new-password"
              :rules="[rules.required, rules.password]"
            ></v-text-field>
            <v-text-field
              filled
              labe="New password"
              type="password"
              required
              v-model="rePassword"
              autocomplete="new-password"
              :rules="[
                rules.required,
                (v) => v === this.password || 'Passwords do not match',
                rules.password
              ]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text class="button color--inactive">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="button"
            color="primary"
            :loading="loading"
            :disabled="!formValid"
            @click="submit"
            >Change password</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { textFieldRules } from '@/common'
import { auth } from '@/firebaseConfig'
import { mapActions } from 'vuex'

export default {
  props: ['code'],
  data: () => ({
    formValid: false,
    loading: false,
    password: '',
    rePassword: '',
    rules: textFieldRules,
    email: null
  }),
  async mounted() {
    try {
      this.email = await auth.verifyPasswordResetCode(this.code)
    } catch (error) {
      this.showError(error.message)
      this.$router.replace({ name: 'login' })
    }
  },
  methods: {
    ...mapActions(['showError', 'showSuccess']),
    async submit() {
      try {
        this.loading = true
        await auth.confirmPasswordReset(this.code, this.password)
        this.showSuccess(
          'Password has been reset. Please login with your new password.'
        )
        this.$router.replace({ name: 'login' })
      } catch (error) {
        console.error(error)
        this.showError(error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
